import React, { useEffect, useState } from 'react'
import LoginLayout from 'Pages/Layout/LoginLayout'
import { RootState } from 'Store'
import { connect, useDispatch } from 'react-redux'
import { Input, FormItem } from 'Components/form'
import { RegisterAccountReq, RegisterTokenReq } from 'Store/user/types'
import { findRegisterTokenAPI, registerNewAccountAPI } from 'Store/user/api'
import { selectEvent, selectRegisterTokenData } from 'Store/user/selector'
import { clearEventAction } from 'Store/user/actions'
import EventModal from 'Components/modal/EventModal'
import { Row } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import ErrorResult from './ErrorResult'
import { appConfig } from 'config'
import InputPassword from 'Components/form/InputPassword'
import { useNavigate, useParams } from 'react-router-dom'

type Props = ReduxProps

const ResetPassword: React.FunctionComponent<Props> = props => {
  const { verifyData, event } = props
  const params = useParams()
  const history = useNavigate()
  const { token } = params

  const [password, setPassword] = useState<string>('')
  const [confirmPassword, setConfirmPassword] = useState<string>('')
  const [requiredError, setRequiredError] = useState<string[]>([])

  const dispatch = useDispatch()

  const onVerifyToken = (): void => {
    const req: RegisterTokenReq = {
      token: token || '',
    }

    dispatch(findRegisterTokenAPI(req))
  }

  useEffect(() => {
    onVerifyToken()
  }, [token])

  const onRegisterAccount = (): void => {
    const req: RegisterAccountReq = {
      token: token || '',
      data: {
        password: password,
        client_id: appConfig.oauthClientId,
      },
    }
    dispatch(registerNewAccountAPI(req))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onSuccess = (): void => {
    clearEvent()
    history('/')
  }

  const gotoHomePage = (): void => {
    history('/')
  }

  const validateInput = (isSubmit: boolean = false): void => {
    let errorInput = [] as string[]
    errorInput = []
    if (password.length < 6) {
      errorInput.push('password')
    }

    if (confirmPassword !== password) {
      errorInput.push('confirmPassword')
    }
    setRequiredError(errorInput)

    if (errorInput.length <= 0 && isSubmit) {
      onRegisterAccount()
    }
  }

  const isError = (key: string) => {
    if (requiredError.includes(key)) {
      return 'error'
    }
    return undefined
  }

  const onUpdatePassword = (val: string): void => {
    setPassword(val)
    if (requiredError.length > 0) {
      validateInput()
    }
  }

  const onUpdateConfirmPassword = (val: string): void => {
    setConfirmPassword(val)
    if (requiredError.length > 0) {
      validateInput()
    }
  }

  const formResetPassword = (
    <LoginLayout
      title={'ระบุรหัสผ่านสำหรับ User ใหม่'}
      onSubmit={() => validateInput(true)}
      btnText="ยืนยัน"
      isLoginMode={false}
    >
      <Row>
        <Text>*จำนวนรหัสผ่านต้องมีอย่างน้อย 6 ตัว</Text>
      </Row>
      <FormItem label="" status={isError('password')} error="รหัสผ่านต้องอย่างน้อย 6 ตัว">
        <InputPassword type="password" value={password} placeholder="รหัสผ่าน" onChange={onUpdatePassword} />
      </FormItem>
      <FormItem label="" status={isError('confirmPassword')} error="รหัสผ่านไม่ตรงกัน">
        <InputPassword
          type="password"
          value={confirmPassword}
          placeholder="ยืนยันรหัสผ่าน"
          onChange={onUpdateConfirmPassword}
        />
      </FormItem>
    </LoginLayout>
  )

  const errorResult = <ErrorResult onClick={gotoHomePage} />

  return (
    <>
      <EventModal
        key="craete-new-password"
        event={[event]}
        enable={true}
        successCalback={onSuccess}
        errorCalback={clearEvent}
      />
      {verifyData ? formResetPassword : errorResult}
    </>
  )
}

const Text = styled.p`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const mapStateToProps = (state: RootState): any => {
  return {
    event: selectEvent(state),
    verifyData: selectRegisterTokenData(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ResetPassword)
